module.exports = __webpack_public_path__ + "img/arrow.2fc06e2a.svg";